import store from "@/store";

export default {
  // 商户有码商
  MER_ROLE_WITH_DEVICE: "1125076279838638080",
  // 商户无码商
  MER_ROLE_WITH_NO_DEVICE: "1125070436338499584",
  // 一级代理商有码商
  FIRST_AGENT_ROLE_WITH_DEVICE: "1125409954740568064",
  // 一级代理无码商
  FIRST_AGENT_ROLE_WITH_NO_DEVICE: "1125410685723869184",
  // 二级代理有码商
  SECOND_AGENT_ROLE_WITH_DEVICE: "1125414162776719360",
  // 二级代理无码商
  SECOND_AGENT_ROLE_WITH_NO_DEVICE: "1125414473465593856"
};

export const PAYMENT_TYPE_ID_COLLECTION = "110"; // 代收
export const PAYMENT_TYPE_ID_PAYMENT = "120"; // 代付

export const ROLE_TYPE = {
  // Admin-管理员
  SUPER_ADMIN: "1070960390067716097",
  // Engineer-技术
  ENGINEER: "1005820484679656505",
  // Mer-商戶
  MERCHANT: "1125070436338499584",
  // Staff-商户员工
  STAFF: "1125410685723999999",
  // Agent-代理
  AGENT: "2125410685723869666",
  // 商務客服主管
  BUSINESS_CUSTOMER_SERVICE_MANAGE: "2712839856536125458",
  // 客服
  CUSTOMER_SERVICE_STAFF:"2712839856536125459",
  // 财务
  FINANCE:"2712839856536125460",
  // 运营
  OPERATOR:"2712839856536125461",
  // 数据员
  DATA_CLERK:"8100123189205217382",
  // 投诉处理专员
  COMPLAINTS_HANDLING_SPECIALIST:"8142742818404501695",

  isManager: function () {
    const roleId = store.state.roleId;
    return roleId === this.SUPER_ADMIN || roleId === this.ENGINEER|| roleId === this.BUSINESS_CUSTOMER_SERVICE_MANAGE ||
        roleId === this.CUSTOMER_SERVICE_STAFF || roleId === this.FINANCE || roleId === this.OPERATOR ||
        roleId === this.DATA_CLERK || roleId === this.COMPLAINTS_HANDLING_SPECIALIST;
  },
  // isEngineer: function () {
  //     return store.state.roleId === this.ENGINEER;
  // },
  isAgent: function() {
    return store.state.roleId === this.AGENT;
  },
  isMerchant: function () {
    return store.state.roleId === this.MERCHANT;
  },
  isMerchantStaff: function () {
    return store.state.roleId === this.STAFF;
  },
  /** 商戶主帳、商戶員工（与后端 init-data mer / staff 一致） */
  isMerchantRelated: function () {
    return this.isMerchant() || this.isMerchantStaff();
  },
  isBusinessCustomerServiceManage: function () {
    return store.state.roleId === this.BUSINESS_CUSTOMER_SERVICE_MANAGE;
  },
  isCustomerServiceStaff: function () {
    return store.state.roleId === this.CUSTOMER_SERVICE_STAFF;
  },
  isFinance: function () {
    return store.state.roleId === this.FINANCE;
  },
  isEnabledCredit: function (){
    return store.state.creditFlag === true;
  }
};
